module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctp",
    attrs: {
      "id": "p0026-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_19",
      "id": "sn_19"
    }
  }, [_vm._v("DAY 19")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_19"
    }
  }, [_vm._v("WHEW! I MEAN, THANK YOU!")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("God remembered Noah . . . and he sent a wind over the earth . . . The water receded steadily. . . . The ark came to rest. ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "p0026-P-1"
    }
  }, [_c('span', [_c('i', [_vm._v("Then God said to Noah, “Come out of the ark . . .”")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', [_c('i', [_vm._v("So Noah came out. All the animals . . . came out of the ark. ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "p0026-P-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Then Noah built an altar to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS")]), _vm._v(" 8:1, 3–4, 15–16, 18–20")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0026-04-5"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("N")]), _vm._v("oah and his family spent a week on the ark before the rain began (Genesis 7:4). Then came forty days and forty nights of rain (v. 12), and the resulting flood lasted for a hundred and fifty days (v. 24). For another one hundred and fifty days the water steadily receded (8:3). After forty days, Noah sent a raven and then a dove for any sign that the earth was dry. Seven days later the dove went out again and this time returned with an olive leaf. Then God spoke: “Come out of the ark.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What would your reaction have been? “Whew!” “Glad that’s over!” “I never want to visit a zoo as long as I live!” Noah’s reaction was none of those. He built an altar, worshiped the Lord, and thanked him for his faithfulness. A good example for all of us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("MAY WE REACT TO GOD’S FAITHFULNESS NOT JUST WITH RELIEF BUT WITH REJOICING!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3bb5f6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter22.vue
// module id = 126
// module chunks = 0